import Vue from 'vue'

Vue.directive('tenant', require('./tenant').default)
